import { render, staticRenderFns } from "./PhotoAnnounce.vue?vue&type=template&id=51188dc8"
import script from "./PhotoAnnounce.vue?vue&type=script&lang=ts"
export * from "./PhotoAnnounce.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports